import { Controller } from '@hotwired/stimulus'

/**
 * SubmitButton Controller
 * Displays a loading button state when a form submission is started
 * It relies on @hotwired/turbo events to display and hide the loading state
 *
 * https://daisyui.com/components/loading/
 */

export class SubmitButtonController extends Controller {
  connect () {
    this.element.addEventListener('turbo:submit-start', this.disableButton)
    this.element.addEventListener('turbo:submit-end', this.enableButton)
  }

  disableButton = event => {
    const button = event.detail.formSubmission.submitter
    if (!button) return

    // Capture styles BEFORE disabling. DaisyUI 5 overrides --btn-fg to
    // near-transparent on :disabled, turning the button gray and hiding
    // the spinner. We preserve the original colors for a polished look.
    const styles = window.getComputedStyle(button)
    const spinnerColor = styles.color
    const bgColor = styles.backgroundColor

    button.style.width = `${button.offsetWidth}px`
    button.setAttribute('data-submit-button-original-html', button.innerHTML)
    button.innerHTML = `<span class="loading loading-spinner loading-sm" style="color: ${spinnerColor}"></span>`
    button.setAttribute('disabled', '')

    // Override DaisyUI's disabled styling to keep the primary tone
    button.style.backgroundColor = bgColor
    button.style.opacity = '0.7'
  }

  enableButton = event => {
    const button = event.detail.formSubmission.submitter
    if (!button) return

    const originalHtml = button.getAttribute('data-submit-button-original-html')
    if (originalHtml !== null) {
      button.innerHTML = originalHtml
      button.removeAttribute('data-submit-button-original-html')
    }

    button.style.width = ''
    button.style.backgroundColor = ''
    button.style.opacity = ''
    button.removeAttribute('disabled')
  }
}
